import { useI18n } from "../context/I18nContext";
import { Overline, Reveal } from "./Reveal";

export default function Intro() {
  const { t } = useI18n();

  return (
    <section id="concepto" data-testid="intro-section" className="bg-cream py-24 text-charcoal md:py-36">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>{t.intro.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-3xl leading-[1.15] sm:text-4xl lg:text-[2.75rem]">
              {t.intro.title}
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.12}>
            <p className="font-corm text-2xl italic leading-snug text-charcoal/90 md:text-[1.7rem]">
              {t.intro.p1}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-charcoal/70">{t.intro.p2}</p>
          </Reveal>
          <Reveal delay={0.28}>
            <p className="mt-8 text-[11px] uppercase tracking-[0.25em] text-stonekw">{t.intro.meta}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
